<template>
    <div class="pt-7">
      
  </div>
</template>

<script>
let apiEndpoint = process.env.VUE_APP_API_BASEURL

export default {
  name: 'Logout',
  components: {
  },
  data() {
    return {
      uploads: [],
    };
  },
  methods: {
    logoutUser() {
        // Set state
        this.$store.commit('setLoggedIn', false)
        // Remove localstorage
        localStorage.removeItem('screenedToken');

        // Redirect to login
        this.$router.push('Login') 
    },
  },
  created() {
    this.logoutUser();
  },
}
</script>
